import React from 'react'

const ArrowDown = props => (
  <svg width="24" height="24" fill="none" {...props}>
    <path d="m7 9.95 4.95 4.2 4.95-4.2" stroke="currentColor" />
  </svg>
)

export default ArrowDown
